

// below is to switch between xhr (if provided in options) or keep it as XMLHttpRequest
// let HttpRequest = xhr || XMLHttpRequest 
let HttpRequest = XMLHttpRequest


function getXmlHttp(uri, logger){
  /* code for IE6, IE5 */
  // else {
  //   xmlhttp = new AjaxIE<T>('Microsoft.XMLHTTP');
  // }
  //https://stackoverflow.com/questions/41474445/xmlhttprequest-does-not-exist-on-type-window
  // if ((<any>window).XMLHttpRequest) {
  //   xmlhttp = new XMLHttpRequest();
  // } else {
  //   xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  // }
  const xmlhttp = new HttpRequest();

  xmlhttp.onreadystatechange = function() {
    if (this.readyState === 4) {
      try {
        const jsonRpc = JSON.parse(xmlhttp.responseText);
        logger.log('<=', jsonRpc);
        this.callback(xmlhttp.status, jsonRpc);
      }
      catch(e) {
        // callback(xmlhttp.status, { error: SktErrors.ESKT_COMMUNICATIONERROR, message: 'Did not receive a JSON object' });
        logger.log('error', xmlhttp.resonseText);
        logger.log('error', e);
        this.callback(xmlhttp.status, { error: -1, message: 'Did not receive a JSON object' });
      }
    }
  };

  xmlhttp.sendJsonRpc = function (jsonRpc) {
    const promise = new Promise((resolve, reject)=> {
      const jsonRpcString = JSON.stringify(jsonRpc);
      this.callback = (status, jsonRpcResponse) => {
        if(status === 200){
          resolve(jsonRpcResponse);
        }
        else{
          reject(jsonRpcResponse);
        }
      };
      this.open('POST', uri, true);
      this.setRequestHeader('Content-Type', 'application/json');
      this.send(jsonRpcString);
      logger.log('=>', jsonRpc);
    });
    return promise;
  };
  return xmlhttp;
}

// Ajax dealing with JRpcRequest, JRpcResponse and JRpcError
class JsonRpc {
  constructor(uri, logger) {
    this.uri = uri;
    this.logger = logger;
  }

  async sendRequest(request) {
    const xmlHttp = getXmlHttp(this.uri, this.logger);
    const response = await xmlHttp.sendJsonRpc(request);
    if(response.error){
      throw response;
    }
    return response;
  }

}

export default JsonRpc;


